import { render, staticRenderFns } from "./suites.vue?vue&type=template&id=5466b3a8"
import script from "./suites.vue?vue&type=script&lang=js"
export * from "./suites.vue?vue&type=script&lang=js"
import style0 from "./suites.vue?vue&type=style&index=0&id=5466b3a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports